import { put, take, fork, select, call } from 'redux-saga/effects';
import api from '../../api/services';

import { actionTypes } from '../actions/user';

const getAccessToken = state => state.login.auth.access_token;

export function * doGetUserProfile() {
  const authorization = yield select(getAccessToken);
  const { response, error } = yield call(api.userServices.userStatusService, { authorization });
  // console.log(response);
  // console.log(error);
  if (!error) {
    yield put({ type: actionTypes.USER_STATUS_OK, payload: {} });
  } else {
    yield put({ type: actionTypes.USER_STATUS_KO, payload: {} });
  }
}

export function * watchGetUserProfile() {
  // eslint-disable-next-line no-constant-condition, no-loops/no-loops
  while (true) {
    yield take(actionTypes.USER_STATUS);
    yield fork(doGetUserProfile);
  }
}

export default [
  fork(watchGetUserProfile),
];
